module.exports = "//public.zight.com/packs/media/images/annotate/text-bf482274bb83e58bdbefce439003cbe3.svg";